import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { Node as ProseMirrorNode } from '@tiptap/pm/model'
import { Editor } from '@tiptap/core'
import { cn } from '@/lib/utils'
import { GlossaryAttributes } from './glossary-extension'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui'

interface GlossaryNodeViewProps {
  node: ProseMirrorNode
  editor: Editor
  getPos: () => number | undefined
  updateAttributes: (attributes: Record<string, any>) => void
  deleteNode: () => void
  selected: boolean
}

export function GlossaryNodeView({
  node,
  editor,
  getPos,
  updateAttributes,
  deleteNode,
  selected,
}: GlossaryNodeViewProps) {
  const attrs = node.attrs as GlossaryAttributes

  return (
    <NodeViewWrapper
      as="span"
      className={cn(
        'inline',
        selected && 'ProseMirror-selectednode'
      )}
      data-type="Glossary"
      data-term={attrs.term}
      data-definition={attrs.definition}
      data-glossary="true"
    >
      {attrs.definition ? (
        <HoverCard openDelay={200} closeDelay={100}>
          <HoverCardTrigger asChild>
            <span className='font-bold cursor-help'>
              {attrs.term || 'Term'}
            </span>
          </HoverCardTrigger>
          <HoverCardContent className='w-80 text-sm'>
            <div>
              <div className='mb-1 font-semibold'>{attrs.term}</div>
              <div className='text-muted-foreground'>{attrs.definition}</div>
            </div>
          </HoverCardContent>
        </HoverCard>
      ) : (
        <span className='font-bold'>
          {attrs.term || 'Term'}
        </span>
      )}
    </NodeViewWrapper>
  )
} 